import { Store } from '../type';
import { IPivotMobileCaptchas, IGetMobileCaptchaState } from './constants';

interface Params {
  API: {
    startCountDown: (duration?: number) => void;
    getMobileCaptcha: (mobile: string, type: IPivotMobileCaptchas, slidingCaptcha:any) => Promise<any>;
  };
  state: Store<{
    mobileCaptchaeLoading: boolean;
    mobileCaptchaeError: string;
  }>;
}

export default class MobileCaptcha {
  private _API;
  public state;

  constructor(params: Params) {
    this._API = params.API;
    this.state = params.state;
  }

  async getMobileCaptcha(mobile: string, type: IPivotMobileCaptchas = 3, slidingCaptcha:any) {
    this.state.set({ mobileCaptchaeLoading: true });
    this.state.set({ mobileCaptchaeError: '' });
    try {
      await this._API.getMobileCaptcha(mobile, type, slidingCaptcha);
      // 倒计时
      this._API?.startCountDown();
      return IGetMobileCaptchaState.SUCCESS;
    } catch (e: any) {
      const res = e.response.data;
      if (res?.code === 4031000) {
        // 60秒内不能重复获取验证码
        this.state.set({
          mobileCaptchaeError: '获取验证码过于频繁，请稍后再试'
        });
        // 倒计时继续
        const limitDuration = Number(res?.message);
        this._API?.startCountDown(limitDuration);
        return IGetMobileCaptchaState.SECURITY_RESTRICTIONS;
      } else {
        this._API?.startCountDown();
        this.state.set({ mobileCaptchaeError: '获取验证码失败，请稍后再试' });
        return IGetMobileCaptchaState.UNKONW;
      }
    } finally {
      this.state.set({ mobileCaptchaeLoading: false });
    }
  }
}

export * from './constants';
